import React, { useState, useEffect } from "react";
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import Skeleton from '@mui/material/Skeleton';
import getCandidateStatusByStatusCode from "../../apis/getCandidateStatusByStatusCode/getCandidateStatusByStatusCode";
import getTrackCandidateInfo from "../../apis/getTrackCandidateInfo/getTrackCandidateInfo";
import { useDebounce } from "../recruitmentLeader/hook.js";
import "./UpcomingStart.css";
import "react-datepicker/dist/react-datepicker.css";
import TextField from "@mui/material/TextField";
import DownArrowIcon from "../Icons/downarrowicon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UpcomingStart = ({ idContextTest, userType, userRole, userRecruitmentpartnerId }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [interviewData, setInterviewData] = useState([]);
    const [totalInterViewDataCount, setTotalInterviewDataCount] = useState(0);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const jsonConfig = require("../../Config.json");
    const [currentEventCount, setCurrentEventCount] = useState(0);

    const [page, setPage] = useState(0);
    const rowsPerPage = 5;

    const debouncedSearchStartDate = useDebounce(startDate, 300);
    const debouncedSearchEndDate = useDebounce(endDate, 300);

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: "numeric", month: "short", year: "numeric" };
        return date.toLocaleDateString("en-US", options);
    }

    function convertDate(dateString) {
        if (dateString) {
            const date = new Date(dateString),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        } else return dateString;
    }

    const startDateChangeHandler = (date) => {
        setStartDate(date);
    };
    const endDateChangeHandler = (date) => {
        setEndDate(date);
    };

    const columns = [
        { id: 'candidateName', label: 'Candidate Name' },
        { id: 'referenceId', label: 'Reference ID' },
        { id: 'clientName', label: 'Client Name' },
        { id: 'startedDate', label: 'Starting Date' },
    ];

    const getInterviewDetails = async (isScroll) => {
        let response;
        try {
            setIsDataLoading(true)

            let payloadData = {
                isCurrentEventCount: true,
                candidateStatusCode: [jsonConfig.candidateRequisitionStatusCode.SELECTED, jsonConfig.candidateRequisitionStatusCode.STARTED, jsonConfig.candidateRequisitionStatusCode.Offer_Accepted, jsonConfig.candidateRequisitionStatusCode.Offer_Extended],
                searchData: {},
                recruitmentpartnerId: userRecruitmentpartnerId,
                userRecruitmentpartnerId: userRecruitmentpartnerId,
                userId: idContextTest,
                role: userType,
                origin: "upcomingStarts"
            }
            if (userType === "Organization Admin" || userType === "MIS Operator" || (userType === "Admin" && userRole === "Organization Admin") || (userType === "Admin" && userRole === "MIS Operator")) {
                payloadData.orgId = userRecruitmentpartnerId
            }
            else if (userType === "Recruiter" || (userType === "Admin" && userRole === "Recruiter")) {
                payloadData.recruiterId = idContextTest
            }
            else if (userType === "Recruitment Leader" || (userType === "Admin" && userRole === "Recruitment Leader")) {
                payloadData.recruitmentLeaderId = idContextTest
            } else if (userType === "Team Leader" || (userType === "Admin" && userRole === "Team Leader")) {
                payloadData.teamLeaderId = idContextTest
            }

            let candidateInterviewData = isScroll ? interviewData : []
            let today = new Date();
            let threeDaysLater = new Date();
            let twoDaysLater = new Date();
            let oneDaysLater = new Date();
            threeDaysLater = formatDate(threeDaysLater.setDate(today.getDate() + 3));
            twoDaysLater = formatDate(twoDaysLater.setDate(today.getDate() + 2));
            oneDaysLater = formatDate(oneDaysLater.setDate(today.getDate() + 1));

            let pageCount = isScroll ? page + 1 : 1
            setPage(pageCount)

            // if (startDate && endDate) {
            payloadData.fromdate = convertDate(startDate)
            payloadData.todate = convertDate(endDate)
            payloadData.page = pageCount
            payloadData.size = rowsPerPage
            // }

            response = await getCandidateStatusByStatusCode(payloadData);

            setCurrentEventCount(response.data?.currentEventCount || 0)
            setTotalInterviewDataCount(response.data?.totalCount)
            response = response.data?.data

            response.forEach((details) => {
                let matchData = details.eventStatus.find(
                    (item) => item.candidateStatusCode === details.status.candidateStatusCode
                );

                let startedDate = matchData?.activityLogs[0]?.startedDate
                    ? matchData?.activityLogs[0]?.startedDate
                    : matchData?.activityLogs[0]?.eventDate;

                let candidateInterviewDate = formatDate(startedDate);

                candidateInterviewData.push({
                    candidateName: details.name,

                    referenceId: details?.requisitiondetails?.reqreferenceId,
                    clientName: details.clientdata?.clientName,
                    startedDate: formatDate(startedDate),
                    rawStartedDate: new Date(startedDate),
                    email: details.email,
                    interviewAlert: (candidateInterviewDate === formatDate(today) || candidateInterviewDate === oneDaysLater || candidateInterviewDate === twoDaysLater || candidateInterviewDate === threeDaysLater) ? true : false
                });
            });


            candidateInterviewData.sort((a, b) => a.rawStartedDate - b.rawStartedDate);

            candidateInterviewData = candidateInterviewData.map(({ rawStartedDate, ...rest }) => rest);



            setInterviewData(candidateInterviewData);
            setIsDataLoading(false)
        } catch (error) {
            console.log("Error", error);
        }

    }
    const goToCandidateProfile = async (itemValue) => {
        try {
            const response = await getTrackCandidateInfo({
                candidateEmail: itemValue.email,
                recruitmentPartnerId: userRecruitmentpartnerId,
            });
            const userData = response?.data?.data?.userDetails[0];
            let url = "";
            if (userData?.powerResumeId) {
                url = "candidate/profile/" + userData?.powerResumeId + "/" + userData.recruitmentOrgId;
            } else {
                url = "only-candidate-profile/" + userData?.candidateId;
            }
            window.open(url, "_blank");
        } catch (error) {
            console.error("Error opening candidate profile:", error);
        }
    };

    useEffect(() => {
        const loadUsers = async () => {
            await getInterviewDetails(false);
        };
        loadUsers();
    }, [debouncedSearchStartDate, debouncedSearchEndDate, userType]);

    return (
        <div className="bento_upcoming bento-wide container-upcoming-table">
            <div className="bento-header-upcoming">
                <div className="bento-header-content">
                    <div className="bento-header-text upcoming_table_header">
                        {currentEventCount === 0 ? (
                            <span>Upcoming Starts</span>
                        ) : (
                            <Tooltip title="Number of candidate having startdate as today" placement="top">
                                <Badge badgeContent={currentEventCount} color="secondary">
                                    <span>Upcoming Starts</span>
                                </Badge>
                            </Tooltip>
                        )}
                    </div>
                    <div className="bento-header-date_upcoming_starts">
                        <div className='date-pill-upcoming'>
                            <DatePicker
                                selected={startDate}
                                className="date-pill-input-upcoming"
                                value={startDate ? startDate : ''}
                                onChange={startDateChangeHandler}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="DD-MM-YYYY"
                                showIcon
                            />
                        </div>

                        <div className='date-pill-upcoming'>
                            <DatePicker
                                selected={endDate}
                                className="date-pill-input-upcoming"
                                value={endDate ? endDate : ''}
                                onChange={endDateChangeHandler}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="DD-MM-YYYY"
                                showIcon
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div className="upcoming-table-container">
                <table className="interview-table">
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th key={col.id}>{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isDataLoading
                            ? Array.from(new Array(rowsPerPage)).map((_, i) => (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            ))
                            : (
                                interviewData.length > 0
                                    ? interviewData.map((row, idx) => (
                                        <tr
                                            key={idx}
                                            className={row.interviewAlert ? "interviewTable_today" : "interviewTable_today_upcomingDate"}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => goToCandidateProfile(row)}
                                        >
                                            {columns.map((column) => (
                                                <td key={column.id}>
                                                    {row[column.id]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                    : (
                                        <tr>
                                            <td colSpan={columns.length} align="center">
                                                No Upcoming Starts
                                            </td>
                                        </tr>
                                    )
                            )}
                    </tbody>
                </table>
            </div>

            {totalInterViewDataCount > interviewData.length && !isDataLoading && (
                <div
                    className="load_more_container_upcoming_table"
                    onClick={() => getInterviewDetails(true)}
                >
                    <p className="load_more_button_upcoming_table">
                        Click Here To View More
                    </p>
                    <DownArrowIcon />
                </div>
            )}
        </div>
    )
}

export default UpcomingStart
